import { Component, EventEmitter, OnInit, Input, Output, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { Message, OverlayPanel, SelectItem, ConfirmDialog, ConfirmationService, SplitButton, MenuItem } from 'primeng/primeng';
import { UIChart } from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as filters from '../../filters/index'
import * as enums from '../../enums/index'
import * as serv from '../../services/index'

//constants
import { Constants } from '../../constants/Constants';

//components
import { MessageHandlerComponent } from '../Controls/MessageHandler.component';
import { BlockComponent } from '../Controls/Block.component';
import { RequestValidationMessagesComponent } from '../../components/Requests/RequestValidationMessages.component';
import { MassUpdateEntityDropdownComponent } from '../DomainData/MassUpdateEntityDropdown.component';
import { SalesOfficeApproverEditComponent } from './SalesOfficeApproverEdit.component';


@Component({
    selector: 'my-sales-office-approver-grid',
    templateUrl: './SalesOfficeApproverGrid.component.html'
})
export class SalesOfficeApproverGridComponent implements OnInit {

    userInfo: ent.UserInfo;
    @ViewChild(MessageHandlerComponent) messageHandlerComponent: MessageHandlerComponent;
    @ViewChild(BlockComponent) blockComponent: BlockComponent;
    @ViewChild(SalesOfficeApproverEditComponent) salesOfficeApproverEditComponent: SalesOfficeApproverEditComponent;
    cols: any[] = [];
    records: any[];
    editedRecord: ent.SalesOfficeApprover = new ent.SalesOfficeApprover();

    constructor(private configService: serv.ConfigService, private authenticationService: serv.AuthenticationService,
      private employeeService: serv.EmployeeService, private router: Router) {

    }

    ngOnInit(): void {

      if (!this.authenticationService.checkLoginStatus()) {
            this.router.navigate(['login']);
        }
        this.userInfo = this.authenticationService.getUserInfo();
        this.salesOfficeApproverEditComponent.salesOfficeDropdown.load();
        this.salesOfficeApproverEditComponent.equipmentClassDropdownComponent.load();
        this.salesOfficeApproverEditComponent.approvalTypeDropdownComponent.load();
        
        this.loadColumns();
        this.onSearchClick(null);

    }


    loadColumns() {
        let cols = [
            { field: 'ID', header: 'ID', width: '7em'},
            { field: 'Employee.FirstName', header: 'First Name', width: '10em' },
            { field: 'Employee.LastName', header: 'Last Name' },
            { field: 'Employee.Username', header: 'Username', width: '10em' },
            { field: 'SalesOffice.ID', header: 'Sales Office ID', width: '7em' },
            { field: 'SalesOffice.Number', header: 'Sales Office Number', width: '7em' },
            { field: 'SalesOffice.Name', header: 'Sales Office Name' },
            { field: 'ApprovalType.Name', header: 'Approval Type' },
            { field: 'EquipmentClass.Name', header: 'Equipment Class' },
            { field: 'Inactive', header: 'Inactive', width: '7em' },
        ];

        for (var col of cols) {
            this.cols = [...this.cols, col];
        }

    }

    onSalesOfficeApproverEditOK(){

      var request: ent.SaveSalesOfficeApproverRequest = {SalesOfficeApprover: this.editedRecord, SavedByEmployee: this.userInfo.Employee};
      this.employeeService.saveSalesOfficeApprover(request).subscribe(x=>{
          this.messageHandlerComponent.handleResponse(x);
          this.onSearchClick(null);
      });

    }

    onSearchClick(event: any){

      this.blockComponent.blocked = true;
      this.employeeService.getSalesOfficeApprovers().subscribe(x=>
          {
              this.records = x;
              this.blockComponent.blocked = false;
          }, err => 
          {
            this.messageHandlerComponent.handleResponse({Success: false, ValidationMessages: [{Category: "error", MessageText: err}]})
          this.blockComponent.blocked = false;
          }
      );
    }

    onAddClick(event: any){
        this.editedRecord = new ent.SalesOfficeApprover();
        this.editedRecord.EmployeeID = Constants._NONE;
        
        this.salesOfficeApproverEditComponent.setEmployeeAutoCompleteValue(Constants._NONE);
        this.salesOfficeApproverEditComponent.salesOfficeDropdown.value = Constants._NONE;
        this.salesOfficeApproverEditComponent.approvalTypeDropdownComponent.value = Constants._NONE;
        this.salesOfficeApproverEditComponent.equipmentClassDropdownComponent.value = Constants._NONE;
        
        this.salesOfficeApproverEditComponent.displayDialog = true;

        
    }

    onEditClick(event: any, record: ent.SalesOfficeApprover){
        this.editedRecord = record;
        this.salesOfficeApproverEditComponent.salesOfficeDropdown.value = record.SalesOfficeID;
        //this.salesOfficeApproverEditComponent.employeeDropdownComponent.value = record.EmployeeID;

        this.salesOfficeApproverEditComponent.setEmployeeAutoCompleteValue(record.EmployeeID);
        this.salesOfficeApproverEditComponent.approvalTypeDropdownComponent.value = record.ApprovalTypeID;
        this.salesOfficeApproverEditComponent.equipmentClassDropdownComponent.value = record.EquipmentClassID;
        this.salesOfficeApproverEditComponent.displayDialog = true;
    }

    getCellData(row: any, col: any): any {
        const nestedProperties: string[] = col.field.split('.');
        let value: any = row;
        for (const prop of nestedProperties) {
            value = value[prop];
        }

        return value;
    }

    getColumnWidth(col: any) {
        if (!col['width']) {
            return '15em'
        }
        else {
            return col['width'];
        }

    }
}
